module.exports = __webpack_public_path__ + "static/media/flip_phone_plan.a63d1bdc.svg";